import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import React from "react";

/** MOSA-908. Panel header badge for a sample data source. */
export const DemoBadge: React.FC = () => (
  <span
    className="inline-flex shrink-0 items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-normal"
    style={{
      color: "var(--od-primary-text)",
      borderColor: "color-mix(in srgb, var(--od-info) 40%, transparent)",
      backgroundColor: "color-mix(in srgb, var(--od-info) 10%, transparent)",
    }}
    title="This is a sample. Writes are not saved."
    data-testid="sample-badge"
  >
    <ScienceOutlinedIcon sx={{ fontSize: 12 }} aria-hidden /> Sample
  </span>
);
